import { useState,useEffect, isValidElement } from 'react';
import { useDispatch, useSelector } from "react-redux";

import { visualizerActions, uiActions } from "../../store";

import ProductList from '../ProductList/ProductList';

import styles from './Steps.module.css';

// Cabinet step
const CabinetsStep = () => {
    const dispatch = useDispatch();

    const [cabinetColorFilter, setCabinetColorFilter] = useState("na");
    const [activeTab, setActiveTab] = useState("style");  
    const [selectedStyle, setSelectedStyle] = useState(false);
    const [activeColor, setActiveColor] = useState();
    const activeStep = useSelector((state) => state.visualizer.activeStep)
    const specifier = useSelector((state) => state.visualizer.specifier);
    const [doesNotRender, setDoesNotRender] = useState(false);  


    useEffect(() => {
        setDoesNotRender(specifier.indexOf('Misty_Bath') != -1);
    }, [specifier]);

    useEffect(() => {
        let product = activeStep?.selection
        if(product != undefined && product != -1){
            setSelectedStyle(product);
            let filterString = "na";
            if(product.genericDisplayName.length){
                let productIds = product.genericDisplayName.split(",").map(item => item.trim());
                filterString = productIds.map(id => `prod['id'] === ${id}`).join(' || ');
            }
            setCabinetColorFilter(filterString)
            
        }
        if(!activeColor)
            setActiveColor(activeStep?.secondarySelection?? {id:5137548});

    }, [activeStep, selectedStyle, activeColor]);
    

    useEffect(() => {
        if (selectedStyle != false && (!activeColor || activeColor.id == -1))
            setActiveTab('color')
    }, [cabinetColorFilter]);

    useEffect(() => {
        //used to update the color products tier from "standard" to "upgrade" or vice versa
        if(activeTab == 'color'){
            setTimeout(function(){
                const ryeColor = document.querySelector('[data-id="5137548"]');
                let htmlContent = selectedStyle.warranty == 'Upgrade' ? '<img src="/static/media/star.07d380378b41780ffbffad90b5b3c488.svg" width="10" height="10" alt="upgrade"/>  <span>Upgrade</span>' : '<p><img src="/static/media/standard.4b335e44bd62a1192874b4e5e31bbe33.svg" width="10" height="10" alt="standard"> <span class="tier">Standard</span></p>';    

                if (ryeColor) {
                    const ryeTierElement = ryeColor.querySelector('.tier');
                    if (ryeTierElement) {
                        ryeTierElement.innerHTML = htmlContent;
                    }
                }
        
                const truffleColor = document.querySelector('[data-id="5137553"]');
                if (truffleColor) {
                    const truffleElement = truffleColor.querySelector('.tier');
                    if (truffleElement) {
                        truffleElement.innerHTML = htmlContent;
                    }
                }
            },200);

        }
    }, [activeTab]);


    // Handle cabinet style select
    const handleCabinetStyleSelect = (product) => {

        setSelectedStyle(product);
        setSelectedStyle(product);
        dispatch(visualizerActions.setSelection(product));
        let filterString = "na";
        if(product?.genericDisplayName.length){
            let productIds = product.genericDisplayName.split(",").map(item => item.trim());
            filterString = productIds.map(id => `prod['id'] === ${id}`).join(' || ');
        }
        setCabinetColorFilter(filterString)
        setActiveTab('color')
    };

    // Handle cabinet color select
    const handleCabinetColorSelect = (product) => {
        
        
        setActiveColor(product);
        dispatch(visualizerActions.setSecondarySelection(product));

        if(doesNotRender)
            return;

        let color = product.id;
        let door = selectedStyle.id;
        let drawer = selectedStyle.descriptor.split(",")[0].trim();
        let finish = selectedStyle.descriptor.split(",")[1].trim();
        
        document.getElementById('chamViz').applyByFilter("", "", function (newSel, currentSelectedSurface) {
            let selStringValues = String(this.sel).includes('(') ? this.sel.match(/\d+/g) : false;
            dispatch(uiActions.setVizLoading(true));
            if (this.name === "Cabinet Doors") {
                return `${door}(${color})`;
            } else if (this.name === "Cabinet Drawers") {
                return `${finish}(${color})`;
            } else if (this.name === "Cabinet Base" || this.name == 'ASKED TO SKIP -> Island Cabinet Base') {
                dispatch(uiActions.setVizLoading(true));
                return `${drawer}(${color})`;
            }
            
        }, true);

    };


    return (
        <div className={styles.cabinetsStep}>

            <div className={styles.tabControls}>
                <button className={styles.tabBtn + (activeTab === "style"?" active":"")} onClick={() => setActiveTab("style")}>Style</button>
                <button className={styles.tabBtn + (activeTab === "color"?" active":"")} onClick={() => setActiveTab("color")}>Colors</button>
            </div>

            {activeTab === "style" &&
                <>
                    <h5 className={styles.chooseColor}>
                    
                        Choose Style</h5>
                    <ProductList className="cabinetModelSeries" seriesId={8496} selectedProductId={selectedStyle?.id?? -1} doesNotVizualize={doesNotRender} thumbSize="250" filters="prod['categoryName'] === 'Cabinet Doors'" handleSelect={handleCabinetStyleSelect} />
                </>
            }

            {activeTab === "color" &&
                <>
                    
                    <h5 className={styles.chooseColor}>Choose Color</h5>
                    <ProductList className="cabinetColorSeries" seriesId={8497} selectedProductId={activeColor?.id?? -1} doesNotVizualize={doesNotRender} thumbSize="250" filters={cabinetColorFilter} handleSelect={handleCabinetColorSelect} />
                </>
            }
            

        </div>
    )
}

const OptionalCabinetsStep = () => {
    const dispatch = useDispatch();

    const [cabinetColorFilter, setCabinetColorFilter] = useState("na");
    const [activeTab, setActiveTab] = useState("style");  
    const [selectedStyle, setSelectedStyle] = useState(false);
    const [activeOptionalStyle, setActiveOptionalStyle] = useState(false);
    const [activeStandardStyle, setActiveStandardStyle] = useState(false);
    const [activeColor, setActiveColor] = useState();
    const [activeSurface, setactiveSurface] = useState('standard');
    const activeStep = useSelector((state) => state.visualizer.activeStep);

    const [surfaces, setSurfaces] = useState([]);
    const [selectedSurface, setSelectedSurface] = useState(null); 

    const cabinetData = useSelector((state) => state.visualizer.seriesData)[8496];
    const cabinetColorData = useSelector((state) => state.visualizer.seriesData)[8497];

    const [showPerimeterButton, setShowPerimeterButton] = useState(true);
    const [optionalIslandIsSet, setOptionalIslandIsSet] = useState(false);
    

    useEffect(() => {
        let relativeOptionalIslandIsSet = false
        const surfaceList = [
            {
                key:0,
                name:'standard',
                displayName:'Standard Island'
            },

        ];
        document.getElementById('chamViz').applyByFilter("", "", function (newSel, currentSelectedSurface) {
            if (this.name == 'Optional Island Cabinet Doors') {
                if(this.sel != -1){
                    setOptionalIslandIsSet(true);
                    relativeOptionalIslandIsSet = true;
                }
                    

                surfaceList.push({
                    key:1,
                    name:'optional',
                    displayName:'Optional Wrap Around'
                });
                
                let selStringValues = String(this.sel).includes('(') ? this.sel.match(/\d+/g) : false;
                if(selStringValues != false){
                    setActiveOptionalStyle(cabinetData[selStringValues[0]]);
                    setActiveColor(cabinetColorData[selStringValues[1]]);
                }

            }else if(this.name == 'Cabinet Doors'){
                let selStringValues = String(this.sel).includes('(') ? this.sel.match(/\d+/g) : false;

                if(selStringValues != false){
                    setActiveOptionalStyle(cabinetData[selStringValues[0]]);
                    setActiveColor(cabinetColorData[selStringValues[1]]);
                }
            }
        });

        
        // Set the surfaces and select the first one
        if (surfaceList.length > 0) {
            setSurfaces(surfaceList);
            if(relativeOptionalIslandIsSet){
                setSelectedSurface(surfaceList[1].name); 
                handleSurfaceSelect({ target: { name: 'surface-selector', value: surfaceList[1].name } }); 
            }else{
                setSelectedSurface(surfaceList[0].name); 
                handleSurfaceSelect({ target: { name: 'surface-selector', value: surfaceList[0].name } }); 
            }
        
            
        }
    }, []); 

    const handleChange = (e) => {
        setSelectedSurface(e.target.value); 
        handleSurfaceSelect(e);
        setActiveTab('style')
    };

    useEffect(() => {
        let product = activeStep?.selection
        if(product != undefined && product != -1){
            if(activeSurface == 'optional'){
                setSelectedStyle(product);
            }else{
                setSelectedStyle(product);
            }
            let filterString = "na";
            if(product.genericDisplayName.length){
                let productIds = product.genericDisplayName.split(",").map(item => item.trim());
                filterString = productIds.map(id => `prod['id'] === ${id}`).join(' || ');
            }
            setCabinetColorFilter(filterString)
            
        }
        if(!activeColor)
            setActiveColor(activeStep?.secondarySelection?? {id:5137548});

    }, [activeStep, selectedStyle, activeColor]);
    

    useEffect(() => {
        if (selectedStyle != false && (!activeColor || activeColor.id == -1))
            setActiveTab('color')
    }, [cabinetColorFilter]);

    useEffect(() => {
        //used to update the color products tier from "standard" to "upgrade" or vice versa
        if(activeTab == 'color'){
            setTimeout(function(){
                const ryeColor = document.querySelector('[data-id="5137548"]');
                let htmlContent = selectedStyle.warranty == 'Upgrade' ? '<img src="/static/media/star.07d380378b41780ffbffad90b5b3c488.svg" width="10" height="10" alt="upgrade"/>  <span>Upgrade</span>' : '<p><img src="/static/media/standard.4b335e44bd62a1192874b4e5e31bbe33.svg" width="10" height="10" alt="standard"> <span class="tier">Standard</span></p>';    

                if (ryeColor) {
                    const ryeTierElement = ryeColor.querySelector('.tier');
                    if (ryeTierElement) {
                        ryeTierElement.innerHTML = htmlContent;
                    }
                }
        
                const truffleColor = document.querySelector('[data-id="5137553"]');
                if (truffleColor) {
                    const truffleElement = truffleColor.querySelector('.tier');
                    if (truffleElement) {
                        truffleElement.innerHTML = htmlContent;
                    }
                }
            },200);

        }
    }, [activeTab]);

    

    const handleSurfaceSelect = (e) => {
    
        const { name, value} = e.target;
        setactiveSurface(value);

        if(!activeColor || activeColor == -1)
            return;
        
        if(value == 'optional'){
            setSelectedStyle(activeOptionalStyle);
        }else{
            setSelectedStyle(activeStandardStyle);
        }

        


        document.getElementById('chamViz').applyByFilter("", "", function (newSel, currentSelectedSurface) {
            if(this.type == 'CABINETS'){
                let ids = String(this.sel).includes('(') ? this.sel.match(/\d+/g) : [this.sel,this.sel];
                if(this.name.includes('Optional')){
                    if(value != 'optional'){
                        dispatch(uiActions.setVizLoading(true));
                        return -1;
                    }else if(this.sel == -1 && (typeof activeOptionalStyle === 'object' || typeof activeStandardStyle === 'object')){
                        let product = typeof activeOptionalStyle === 'object' ? activeOptionalStyle : activeStandardStyle;
                        let door = product.id;
                        let drawer = product.descriptor.split(",")[0].trim();

                        //setActiveColor(cabinetColorData[ids]);

                        if (this.name === "Optional Island Cabinet Doors") {
                            dispatch(uiActions.setVizLoading(true));
                            return `${door}(${activeColor.id})`;
                        }else if (this.name === "Optional Island Cabinet Base") {
                            dispatch(uiActions.setVizLoading(true));
                            return `${drawer}(${activeColor.id})`;;
                        }
                    }
                    
                }

            }
        }, true);
        
    }

    // Handle cabinet style select
    const handleCabinetStyleSelect = (product) => {

        setSelectedStyle(product);
        dispatch(visualizerActions.setSelection(product));

        // if(activeSurface == 'optional'){
        //     setActiveOptionalStyle(product);
        //     dispatch(visualizerActions.setSelection(product));
        // }else{
        //     setActiveStandardStyle(product);
        //     dispatch(visualizerActions.setSelection(product));
        // }
         
        setActiveStandardStyle(product);
        setActiveOptionalStyle(product);
    
        let filterString = "na";
        if(product?.genericDisplayName.length){
            let productIds = product.genericDisplayName.split(",").map(item => item.trim());
            filterString = productIds.map(id => `prod['id'] === ${id}`).join(' || ');
        }
        
        setCabinetColorFilter(filterString)
        setActiveTab('color')
        
    };

    // Handle cabinet color select
    const handleCabinetColorSelect = (product) => {
        let color = product.id;
        setActiveColor(product);
        dispatch(visualizerActions.setSecondarySelection(product));
        setShowPerimeterButton(true);

        let door;
        let drawer;
        if(activeSurface == 'optional'){
            door = activeOptionalStyle.id;
            drawer = activeOptionalStyle.descriptor.split(",")[0].trim();
        }else{
           
            door = activeStandardStyle.id;
            drawer = activeStandardStyle.descriptor.split(",")[0].trim();
        }

        document.getElementById('chamViz').applyByFilter("", "", function (newSel, currentSelectedSurface) {
            dispatch(uiActions.setVizLoading(true));
            if(activeSurface == 'standard'){
            
                if (this.name == "Island Cabinet Base") {
                    dispatch(uiActions.setVizLoading(true));
                    return `${drawer}(${color})`;
                }else if (this.name === "Optional Island Cabinet Base") {
                    dispatch(uiActions.setVizLoading(true));
                    return -1;
                }

            }else{
                if (this.name === "Optional Island Cabinet Doors") {
                    return `${door}(${color})`;
                }else if (this.name === "Optional Island Cabinet Base" || this.name == "Island Cabinet Base") {
                    dispatch(uiActions.setVizLoading(true));
                    return `${drawer}(${color})`;
                }
            }
            
        }, true);
    };


    // handle Match To Perimeter
    const handleMatchToPerimeter = () => {
        let standardColor = -1;
        document.getElementById('chamViz').applyByFilter("", "", function (newSel, currentSelectedSurface) {
            let selStringValues = String(this.sel).includes('(') ? this.sel.match(/\d+/g) : false;
            if(selStringValues != false){
                dispatch(uiActions.setVizLoading(true));
                if(this.name == 'Cabinet Doors'){
                    standardColor = selStringValues[1];
                    setActiveColor(cabinetColorData[standardColor]);
                }
                    

                if(this.name.includes('Island') && this.sel != `${selStringValues[0]}(${standardColor})`){
                    setShowPerimeterButton(false);
                    return `${selStringValues[0]}(${standardColor})`
                }
            }
            
        });
    };
    


    return (
        <div className={styles.cabinetsStep}>

        {activeStep.id === 31 && surfaces.length > 1 &&
            <div className={styles.radioButtonsContainer}>
                <h5 className={styles.chooseColor}></h5>
                <div className={styles.content}>
                    <ul className={styles.applySurface}>
                        {
                            surfaces.map((surface) => (
                                <li key={surface.key}>
                                    <label htmlFor={`surface-${surface.key}`}>{surface.displayName}</label>
                                    <input
                                        type="radio"
                                        id={`surface-${surface.key}`}
                                        name="surface-selector"
                                        value={surface.name}
                                        checked={selectedSurface === surface.name}
                                        onChange={handleChange}
                                    />
                                </li>
                            ))
                        }
                    </ul>
                </div>
            </div>
        }

            <div className={styles.tabControls}>
                <button className={styles.tabBtn + (activeTab === "style"?" active":"")} onClick={() => setActiveTab("style")}>Style</button>
                <button className={styles.tabBtn + (activeTab === "color"?" active":"")} onClick={() => setActiveTab("color")}>Colors</button>
            </div>

            
            

            {activeTab === "style" &&
                <>
                    <h5 className={styles.chooseColor}>Choose Style</h5>
                    <ProductList className="cabinetModelSeries" seriesId={8496} selectedProductId={selectedStyle?.id?? -1}  thumbSize="250" filters="prod['categoryName'] === 'Cabinet Doors'" handleSelect={handleCabinetStyleSelect} />
                </>
            }

            {activeTab === "color" &&
                <>
                    
                    <h5 className={styles.chooseColor}>Choose Color</h5>
                    {
                        showPerimeterButton && (
                            <button type='button' onClick={handleMatchToPerimeter}>Match to Perimeter</button>
                    )}

                    <ProductList className="cabinetColorSeries" seriesId={8497} selectedProductId={activeColor?.id?? -1}  thumbSize="250" filters={cabinetColorFilter} handleSelect={handleCabinetColorSelect} />
                </>
            }

            
            

        </div>
    )
}

// Kitchen Cabinet Hardware Step

const KitchenCabinetHardwareStep = () => {
    const dispatch = useDispatch();
    const [KitchenCabinetHardwareColorFilter, setKitchenCabinetHardwareColorFilter] = useState("na");
    const activeStep = useSelector((state) => state.visualizer.activeStep);
    const [activeTab, setActiveTab] = useState("style");  
    const [style, setSelectedKitchenCabinetHardwareStyle] = useState(-1);
    const [color, setSelectedKitchenCabinetHardwareColor] = useState(-1);

    const generateFilterString = (product) => {
        if(typeof product !== 'object')
            return 'na';
        let productIds = product.warranty.split(",").map(item => item.trim());
        return productIds.map(id => `prod['id'] === ${id}`).join(' || ');
    }

    useEffect(() => {
    
        
        // Update selected kitchen plumbing style and color
        const kitchenCabinetHardwareStyle = activeStep?.selection;
        const KitchenCabinetHardwareColor = activeStep?.secondarySelection;


        if(typeof kitchenCabinetHardwareStyle === 'object')
            setSelectedKitchenCabinetHardwareStyle(kitchenCabinetHardwareStyle.id);

        if(typeof KitchenCabinetHardwareColor === 'object')
            setSelectedKitchenCabinetHardwareColor(KitchenCabinetHardwareColor.id);

        if(style + color > 0){
            applyKitchenCabinetHardware();
            setKitchenCabinetHardwareColorFilter(generateFilterString(kitchenCabinetHardwareStyle))
        }
            
        
    }, [style, color]); // Dependencies


    
    

    // Handle KitchenCabinetHardware style select
    const handleKitchenCabinetHardwareStyleSelect = (product) => {
        //dispatch(visualizerActions.addToAppliedProducts({ key: 'KitchenFaucet', area:activeStep.area, selString: product.id, dataObject: product }));

        // Reset color selection
        dispatch(visualizerActions.setSecondarySelection({id:-1}));
        setSelectedKitchenCabinetHardwareColor(-1)

        dispatch(visualizerActions.setSelection(product));
        setSelectedKitchenCabinetHardwareStyle(product.id);
        setKitchenCabinetHardwareColorFilter(generateFilterString(product))
        setActiveTab('color')
    };

    // Handle KitchenCabinetHardware color select
    const handleKitchenCabinetHardwareColorSelect = (product) => {
        //dispatch(visualizerActions.addToAppliedProducts({ key: 'KitchenFaucetColor', area:activeStep.area, selString: product.id, dataObject: product }));
        dispatch(visualizerActions.setSecondarySelection(product));
        setSelectedKitchenCabinetHardwareColor(product.id)
    };
    
    const removeKitchenCabinetHardware = () => {
        document.getElementById('chamViz').applyByFilter("", "", function (newSel, currentSelectedSurface) {
            if (this.type === "CABINET HANDLES") {
                dispatch(uiActions.setVizLoading(true));
                return -1;
            }
        }, true);
        dispatch(visualizerActions.setSelection(-1));
        dispatch(visualizerActions.setSecondarySelection(-1));
        setSelectedKitchenCabinetHardwareColor(-1);
        setSelectedKitchenCabinetHardwareStyle(-1);
        setActiveTab('style')
    }

    // Apply KitchenCabinetHardware products
    const applyKitchenCabinetHardware = () => {
        if(style == -1){
            removeKitchenCabinetHardware();
            return false;
        }
            

        let sel = `${style}(${color})`;
        document.getElementById('chamViz').applyByFilter("", "", function (newSel, currentSelectedSurface) {
            let selStringValues = String(this.sel).includes('(') ? this.sel.match(/\d+/g) : false;
            if (this.type === "CABINET HANDLES") {
                dispatch(uiActions.setVizLoading(true));
                return sel;
            }
        }, true);
    }

    

    return (
        <div className={styles.KitchenCabinetHardwareStep}>

            <div className={styles.tabControls}>
                <button className={styles.tabBtn + (activeTab === "style"?" active":"")} onClick={() => setActiveTab("style")}>Style</button>
                <button className={styles.tabBtn + (activeTab === "color"?" active":"")} onClick={() => setActiveTab("color")}>Color</button>
            </div>

            {activeStep.selection.id && activeStep.selection.id != -1 &&
                <>
                    {/* <button type='button' onClick={removeKitchenCabinetHardware}>Remove Hardware</button> */}
                </>
            }

            {activeTab === "style" &&
                <>
                    <h5 className={styles.chooseColor}>Step 1 - Choose Style</h5>
                    <ProductList className="KitchenCabinetHardwareModelSeries" addNoneOption={true} seriesId={8533} selectedProductId={style}  thumbSize="250" filters="na" handleSelect={handleKitchenCabinetHardwareStyleSelect} />
                </>
            }

            {activeTab === "color" &&
                <>
                    <h5 className={styles.chooseColor}>Step 2 - Choose Color</h5>
                    <ProductList className="KitchenCabinetHardwareColorSeries" seriesId={8549} selectedProductId={color}  thumbSize="250" filters={KitchenCabinetHardwareColorFilter} handleSelect={handleKitchenCabinetHardwareColorSelect} />
                </>
            }
            

        </div>
    )
}

// Bathroom Cabinet Hardware Step

const BathroomCabinetHardwareStep = () => {
    const dispatch = useDispatch();
    const [BathroomCabinetHardwareColorFilter, setBathroomCabinetHardwareColorFilter] = useState("na");
    const activeStep = useSelector((state) => state.visualizer.activeStep);
    const [activeTab, setActiveTab] = useState("style");  
    const [style, setSelectedBathroomCabinetHardwareStyle] = useState(-1);
    const [color, setSelectedBathroomCabinetHardwareColor] = useState(-1);
    const specifier = useSelector((state) => state.visualizer.specifier);
    const [doesNotRender, setDoesNotRender] = useState(false);  


    useEffect(() => {
        setDoesNotRender(specifier.indexOf('Misty_Bath') != -1);
    }, [specifier]);

    const generateFilterString = (product) => {
        if(typeof product !== 'object')
            return 'na';
        let productIds = product.warranty.split(",").map(item => item.trim());
        return productIds.map(id => `prod['id'] === ${id}`).join(' || ');
    }


    useEffect(() => {
        
    
        // Update selected Bathroom plumbing style and color
        const BathroomCabinetHardwareStyle = activeStep?.selection;
        const BathroomCabinetHardwareColor = activeStep?.secondarySelection;

        if(typeof BathroomCabinetHardwareStyle === 'object')
            setSelectedBathroomCabinetHardwareStyle(BathroomCabinetHardwareStyle.id);

        if(typeof BathroomCabinetHardwareColor === 'object')
            setSelectedBathroomCabinetHardwareColor(BathroomCabinetHardwareColor.id);

        if(style + color > 0){
            applyBathroomCabinetHardware();
            setBathroomCabinetHardwareColorFilter(generateFilterString(BathroomCabinetHardwareStyle))
        }
            
    }, [style, color]); // Dependencies


    const removeBathroomCabinetHardware = () => {
        if(doesNotRender)
            return

        document.getElementById('chamViz').applyByFilter("", "", function (newSel, currentSelectedSurface) {
            if (this.type === "HANDLE") {
                dispatch(uiActions.setVizLoading(true));
                console.log('removing')
                return -1;
            }
        }, true);
        dispatch(visualizerActions.setSelection(-1));
        dispatch(visualizerActions.setSecondarySelection(-1));
        setSelectedBathroomCabinetHardwareColor(-1);
        setSelectedBathroomCabinetHardwareStyle(-1);
        setActiveTab('style')
    }

    // Handle BathroomCabinetHardware style select
    const handleBathroomCabinetHardwareStyleSelect = (product) => {
        //dispatch(visualizerActions.addToAppliedProducts({ key: 'BathroomFaucet', area:activeStep.area, selString: product.id, dataObject: product }));

        dispatch(visualizerActions.setSecondarySelection({id:-1}));
        setSelectedBathroomCabinetHardwareColor(-1)

        dispatch(visualizerActions.setSelection(product));
        setSelectedBathroomCabinetHardwareStyle(product.id);
        setBathroomCabinetHardwareColorFilter(generateFilterString(product))
        setActiveTab('color')
    };

    // Handle BathroomCabinetHardware color select
    const handleBathroomCabinetHardwareColorSelect = (product) => {
        //dispatch(visualizerActions.addToAppliedProducts({ key: 'BathroomFaucetColor', area:activeStep.area, selString: product.id, dataObject: product }));
        dispatch(visualizerActions.setSecondarySelection(product));
        setSelectedBathroomCabinetHardwareColor(product.id)
    };

    // Apply BathroomCabinetHardware products
    const applyBathroomCabinetHardware = () => {
        if(style == -1){
            removeBathroomCabinetHardware();
            return false;
        }
            

        let sel = `${style}(${color})`;

        if(doesNotRender)
            return
        
        document.getElementById('chamViz').applyByFilter("", "", function (newSel, currentSelectedSurface) {
            let selStringValues = String(this.sel).includes('(') ? this.sel.match(/\d+/g) : false;
            if (this.type === "HANDLE") {
                dispatch(uiActions.setVizLoading(true));
                return sel;
            }
        }, true);
    }

    return (
        <div className={styles.BathroomCabinetHardwareStep}>

            <div className={styles.tabControls}>
                <button className={styles.tabBtn + (activeTab === "style"?" active":"")} onClick={() => setActiveTab("style")}>Style</button>
                <button className={styles.tabBtn + (activeTab === "color"?" active":"")} onClick={() => setActiveTab("color")}>Color</button>
            </div>

            {activeTab === "style" &&
                <>
                    <h5 className={styles.chooseColor}>Step 1 - Choose Style</h5>
                    <ProductList className="BathroomCabinetHardwareModelSeries" addNoneOption={true} doesNotVizualize={doesNotRender} seriesId={8529} selectedProductId={style}  thumbSize="250" filters="na" handleSelect={handleBathroomCabinetHardwareStyleSelect} />
                </>
            }

            {activeTab === "color" &&
                <>
                    <h5 className={styles.chooseColor}>Step 2 - Choose Color</h5>
                    <ProductList className="BathroomCabinetHardwareColorSeries" seriesId={8549} doesNotVizualize={doesNotRender} selectedProductId={color}  thumbSize="250" filters={BathroomCabinetHardwareColorFilter} handleSelect={handleBathroomCabinetHardwareColorSelect} />
                </>
            }
            

        </div>
    )
}

// Kitchen faucet plumbing step

const KitchenPlumbingStep = () => {
    const dispatch = useDispatch();
    const [KitchenPlumbingColorFilter, setKitchenPlumbingColorFilter] = useState("na");
    const activeStep = useSelector((state) => state.visualizer.activeStep);
    const [activeTab, setActiveTab] = useState("style");  
    const [style, setSelectedKitchenPlumbingStyle] = useState(-1);
    const [color, setSelectedKitchenPlumbingColor] = useState(-1);

    useEffect(() => {
        
    
        // Update selected kitchen plumbing style and color
        const faucetStyle = activeStep?.selection.id;
        const faucetColor = activeStep?.secondarySelection.id;

        setSelectedKitchenPlumbingStyle(faucetStyle);
        setSelectedKitchenPlumbingColor(faucetColor);

        if(faucetStyle != -1 && faucetColor != -1)
            applyKitchenPlumbing();
        
    }, [style, color]); // Dependencies

    // Handle KitchenPlumbing style select
    const handleKitchenPlumbingStyleSelect = (product) => {
        //dispatch(visualizerActions.addToAppliedProducts({ key: 'KitchenFaucet', area:activeStep.area, selString: product.id, dataObject: product }));

        // Reset kitchen plumbing colors
        dispatch(visualizerActions.setSecondarySelection({id:-1}));
        setSelectedKitchenPlumbingColor(-1)

        dispatch(visualizerActions.setSelection(product));
        setSelectedKitchenPlumbingStyle(product.id);

        let productIds = product.warranty.split(",").map(item => item.trim());
        let filterString = productIds.map(id => `prod['id'] === ${id}`).join(' || ');
        setKitchenPlumbingColorFilter(filterString);
        // if(!color) Always go back to color
            setActiveTab("color")
    };

    // Handle KitchenPlumbing color select
    const handleKitchenPlumbingColorSelect = (product) => {
        //dispatch(visualizerActions.addToAppliedProducts({ key: 'KitchenFaucetColor', area:activeStep.area, selString: product.id, dataObject: product }));
        dispatch(visualizerActions.setSecondarySelection(product));
        setSelectedKitchenPlumbingColor(product.id)
    };

    // Apply KitchenPlumbing products
    const applyKitchenPlumbing = () => {
        if(style == -1)
            return false;

        let sel = `${style}(${color})`;
        document.getElementById('chamViz').applyByFilter("", "", function (newSel, currentSelectedSurface) {
            let selStringValues = String(this.sel).includes('(') ? this.sel.match(/\d+/g) : false;
            if (this.type === "FAUCET") {
                dispatch(uiActions.setVizLoading(true));
                return sel;
            }
        }, true);
    }

    return (
        <div className={styles.KitchenPlumbingStep}>

            <div className={styles.tabControls}>
                <button className={styles.tabBtn + (activeTab === "style"?" active":"")} onClick={() => setActiveTab("style")}>Style</button>
                <button className={styles.tabBtn + (activeTab === "color"?" active":"")} onClick={() => setActiveTab("color")}>Color</button>
            </div>

            {activeTab === "style" &&
                <>
                    <h5 className={styles.chooseColor}>Step 1 - Choose Style</h5>
                    <ProductList className="KitchenPlumbingModelSeries" seriesId={8532} selectedProductId={style}  thumbSize="250" filters="na" handleSelect={handleKitchenPlumbingStyleSelect} />
                </>
            }

            {activeTab === "color" &&
                <>
                    <h5 className={styles.chooseColor}>Step 2 - Choose Color</h5>
                    <ProductList className="KitchenPlumbingColorSeries" seriesId={8530} selectedProductId={color}  thumbSize="250" filters={KitchenPlumbingColorFilter} handleSelect={handleKitchenPlumbingColorSelect} />
                </>
            }
            

        </div>
    )
}

// Kitchen Backsplash step
const KitchenBacksplashStep = () => {
    const dispatch = useDispatch();
    const activeStep = useSelector((state) => state.visualizer.activeStep);
    const applyBacksplash = (product) => {

        document.getElementById('chamViz').applyByFilter("", "", function (newSel, currentSelectedSurface) {
            if (this.name === "Backsplash") {
                dispatch(uiActions.setVizLoading(true));
                dispatch(visualizerActions.setSelection(product));
                return product.id;
            }
        }, true);

    };

    return (
        <>
            <ProductList
                seriesId={activeStep.series}
                thumbSize="250"
                addNoneOption={true}
                noneOptionTitle='Standard 4" countertop splash'
                selectedProductId={activeStep.selection.id}
                filters={activeStep.filter}
                handleSelect={applyBacksplash}
            />
        </>
    );
};


// Baseboard step
const BaseboardStep = () => {
    const activeStep = useSelector((state) => state.visualizer.activeStep);
    const dispatch = useDispatch();
    const HandleBaseboardSelect = (product) => {
        dispatch(visualizerActions.setSelection(product));
    }

    return (
        <>
          
            <ProductList seriesId={activeStep.series} thumbSize="250" selectedProductId={activeStep.selection.id}  filters={activeStep.filter} doesNotVizualize={true} handleSelect={HandleBaseboardSelect} />
        </>
    )
    
}

// Cabinet Crown Molding step
const CabinetCrownMoldingStep = () => {
    const activeStep = useSelector((state) => state.visualizer.activeStep);
    const dispatch = useDispatch();
    const HandleCabinetCrownSelect = (product) => {
        dispatch(visualizerActions.setSelection(product));
    }

    return (
        <>
         
            <ProductList seriesId={activeStep.series} thumbSize="250" addNoneOption="true" selectedProductId={activeStep.selection.id} filters={activeStep.filter} doesNotVizualize={true} handleSelect={HandleCabinetCrownSelect} />
        </>
    )
}


export { CabinetsStep, OptionalCabinetsStep, KitchenCabinetHardwareStep, BathroomCabinetHardwareStep, KitchenPlumbingStep, KitchenBacksplashStep, BaseboardStep, CabinetCrownMoldingStep };